var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      attrs: { href: "#", name: "HeadSort" },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.handleClick($event)
        }
      }
    },
    [_c("i", { class: _vm.cls })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }